<div class="modal-header">
    <h3 class="modal-title text-uppercase">Membres</h3>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
        <i class="fas fa-times"></i>
    </button>
</div>
<div class="modal-body" *ngIf="circle">
    <app-members [members]="circle.members" [circle]="circle" [memberMe]="memberMe" (onNavigationStart)="bsModalRef.hide()"></app-members>
</div>
